<template>
  <div class="page">
    <div class="app-container">
      <!-- <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch> -->
      <!-- <el-button type="primary" @click="add">新增</el-button> -->
      <BaseTable
        ref="baseTable"
        url="/admin/set/article"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" @click="handleRow(row, 'edit')">编辑</el-button>
          <!-- <el-button type="text" size="mini" @click="handleRow(row, 'del')">删除</el-button> -->
        </template>
      </BaseTable>
            <!-- 修改 -->
        <el-drawer title="协议" size="50%" :visible.sync="isShowDrawer" direction="rtl">
          <!-- <BaseDialog :visible.sync="isShowDrawer" title="服务条款" @confirm="onSubmit"  width = "50%"> -->
              <div style="padding: 30px;">
                <div style="flex"></div>
                <el-form labelWidth="100px" size="medium">
                  <el-form-item label="标题">
                    <el-input  v-model="formData.title" required></el-input>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="照片" prop="storePhoto" >
                    <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
                      list-type="picture-card" :file-list="storePhoto" :limit="5"
                      :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file)"
                      :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList)
                        ">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="具体内容">
                    <editor class="aa"  v-model="formData.content" required></editor>
                  </el-form-item>
                  <el-form-item label="权重">
                    <el-input v-model="formData.sorts" required></el-input>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="状态" prop="status">
                    <el-select v-model="formData.status" filterable>
                      <el-option label="显示" value="1"></el-option>
                      <el-option label="隐藏" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form>
              </div>
        </el-drawer>
        <el-dialog :visible.sync="preVisible">
          <img width="100%" :src="preImageUrl" alt="" />
        </el-dialog>
        <!-- </BaseDialog> -->
    </div>
  </div>
</template>
<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Problem",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      isShowDrawer:false,
      formData:{},
      storePhoto:[],
      id:0,
      preVisible: false,
      preImageUrl: "",
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    
  },
  methods: {
    // 图片上传之前
    handlePictureCardPreview(file) {
        this.preImageUrl = file.url;
        this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList) {
        this.storePhoto = this.storePhoto.filter((el) => el.url !== res.url);
    },

    async handleChangeFile(file) {
      this.loading = true;
      const fd = new FormData();
      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this.storePhoto.push({
          imageType: 1,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    async onSubmit(){
      if(this.formData.title == '' || !this.formData.title){
        this.$message.warning("标题不能为空");
        return;
      }
      if(this.formData.content == '' || !this.formData.content){
        this.$message.warning("内容不能为空");
        return;
      }
      if(this.formData.sorts == '' || !this.formData.sorts){
        this.$message.warning("权重不能为空");
        return;
      }
      if(this.formData.status == '' || !this.formData.status){
        this.$message.warning("请选择状态");
        return;
      }
      this.formData.storePhoto = [
        ...this.storePhoto,
      ];
      let query = await this.$api.post(
        "/admin/set/articlesave",
        { ...this.formData , id: this.id || 0},
      );
      if(query.code == 10000){
        this.isShowDrawer = false;
        this.handleSearch();
        this.id = 0
      }
    },
    // 打开新增退统弹窗
    add() {
      this.id = 0
      this.formData = {};
      this.isShowDrawer = true;
    },
    handleRow(row, k) {
      switch (k) {
        case "edit":
          this.handleEdit(row);
          break;
        case "del":
          this.handleDel(row);
          break;
        default:
          break;
        }
    },
    // 点击编辑
    async handleEdit({ id }) {
      this.id = id
      const res = await this.$api.post("/admin/set/getArticleDetails", {
        id: id,
      });
      this.formData = res.data.data;
      this.storePhoto = res.data.storePhoto;
      this.isShowDrawer = true;
    },
   // 点击删除
   handleDel({ id }) {
      this.$confirm(`是否确认删除【ID${id}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/set/del",
            { id: id },
            "删除"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>

<style scoped>
.aa{
  height: 300px;
}
</style>